import { Component, Input, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { Observable } from 'rxjs';

import { trackByValue } from 'v2/modules/shared/util/track-by.util';

import { IKeyValue } from '../../interfaces/common.interface';

import { LocationApiService } from './../../services/api/location/location-api.service';

@Component({
  selector: 'lum-country-autocomplete',
  templateUrl: './country-autocomplete.component.html',
  styleUrls: ['./country-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryAutocompleteComponent),
      multi: true,
    },
  ],
})
export class CountryAutocompleteComponent implements ControlValueAccessor, OnInit {
  @Input() formControl :UntypedFormControl;
  @Input() disabled :boolean = false;
  selectedCountry :any = null;

  trackByValue = trackByValue;

  private onChange :(value :any) => void = () => {};
  private onTouched :() => void = () => {};

  constructor(private locationApiService :LocationApiService) {}

  ngOnInit() :void {
    this.locationApiService.getCountries();
  }

  writeValue(value :any) :void {
    this.selectedCountry = value;
  }

  registerOnChange(fn :(value :any) => void) :void {
    this.onChange = fn;
  }

  registerOnTouched(fn :() => void) :void {
    this.onTouched = fn;
  }

  onSelectChange(event :MatSelectChange) :void {
    const value = event.value;
    this.selectedCountry = value;
    this.onChange(value);
    this.onTouched();
  }

  get countries$() :Observable<IKeyValue[]> {
    return this.locationApiService.countries$;
  }
}
